import { render, staticRenderFns } from "./HomeInfosDialog.vue?vue&type=template&id=13c54e3d"
import script from "./HomeInfosDialog.vue?vue&type=script&lang=js"
export * from "./HomeInfosDialog.vue?vue&type=script&lang=js"
import style0 from "./HomeInfosDialog.vue?vue&type=style&index=0&id=13c54e3d&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports